document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const drawer = document.getElementById('AyrosMobileDrawer');
  const backdrop = document.querySelector('[data-ayros-menu-close].ayros-drawer-backdrop');
  const openers = document.querySelectorAll('[data-ayros-menu-open]');
  const closers = document.querySelectorAll('[data-ayros-menu-close]');

  function setDrawer(open) {
    if (!drawer || !backdrop) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    backdrop.hidden = !open;
    requestAnimationFrame(() => backdrop.classList.toggle('is-open', open));
    body.classList.toggle('ayros-drawer-open', open);
    openers.forEach(btn => btn.setAttribute('aria-expanded', open ? 'true' : 'false'));
  }

  openers.forEach(btn => btn.addEventListener('click', () => setDrawer(true)));
  closers.forEach(btn => btn.addEventListener('click', () => setDrawer(false)));
  drawer?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') setDrawer(false);
  });

  document.querySelectorAll('.ayros-menu-item--mega').forEach(item => {
    const panel = item.querySelector('.ayros-mega-menu');
    let closeTimer;

    const openMega = () => {
      clearTimeout(closeTimer);
      item.classList.add('is-open');
      panel?.setAttribute('aria-hidden', 'false');
    };

    const closeMega = () => {
      closeTimer = setTimeout(() => {
        item.classList.remove('is-open');
        panel?.setAttribute('aria-hidden', 'true');
      }, 220);
    };

    item.addEventListener('mouseenter', openMega);
    item.addEventListener('mouseleave', closeMega);
    item.addEventListener('focusin', openMega);
    item.addEventListener('focusout', closeMega);
  });

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (canHover) {
    document.querySelectorAll('.ayros-hero, .ayros-split').forEach(section => {
      section.addEventListener('pointermove', event => {
        const rect = section.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 2;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * 2;
        section.style.setProperty('--mx', x.toFixed(3));
        section.style.setProperty('--my', y.toFixed(3));
      });
      section.addEventListener('pointerleave', () => {
        section.style.setProperty('--mx', '0');
        section.style.setProperty('--my', '0');
      });
    });
  }

  const revealTargets = document.querySelectorAll([
    '.ayros-hero',
    '.ayros-section',
    '.ayros-split',
    '.ayros-below',
    '.ayros-product-card',
    '.ayros-review',
    '.ayros-note',
    '.ayros-panel'
  ].join(','));

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    revealTargets.forEach((target, index) => {
      target.classList.add('ayros-reveal');
      target.style.setProperty('--reveal-delay', `${Math.min(index % 6, 5) * 55}ms`);
      revealObserver.observe(target);
    });
  } else {
    revealTargets.forEach(target => target.classList.add('is-visible'));
  }

  document.querySelectorAll('[data-ayros-track]').forEach(track => {
    const id = track.getAttribute('data-ayros-track');
    const step = () => Math.max(260, Math.floor(track.clientWidth * 0.75));
    document.querySelectorAll(`[data-ayros-left="${id}"]`).forEach(btn => btn.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' })));
    document.querySelectorAll(`[data-ayros-right="${id}"]`).forEach(btn => btn.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' })));
  });

  const reviewForm = document.querySelector('[data-ayros-review-form]');
  document.querySelectorAll('[data-ayros-review-open]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!reviewForm) return;
      reviewForm.hidden = false;
      reviewForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
      reviewForm.querySelector('input, select, textarea')?.focus({ preventScroll: true });
    });
  });
  document.querySelectorAll('[data-ayros-review-close]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!reviewForm) return;
      reviewForm.hidden = true;
      document.querySelector('.ayros-review-summary')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  document.querySelectorAll('.ayros-dual--mobile-gallery-slider').forEach(section => {
    const gallery = section.querySelector('.ayros-gallery');
    const hint = section.querySelector('[data-ayros-gallery-hint]');
    const bar = section.querySelector('[data-ayros-gallery-progress]');
    const count = section.querySelector('[data-ayros-gallery-count]');
    if (!gallery || !hint || !bar) return;
    const slides = Array.from(gallery.querySelectorAll('.ayros-photo'));
    if (!slides.length) return;

    const updateGalleryHint = () => {
      const maxScroll = Math.max(1, gallery.scrollWidth - gallery.clientWidth);
      const progress = Math.min(1, Math.max(0, gallery.scrollLeft / maxScroll));
      const current = Math.min(slides.length, Math.max(1, Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth)) + 1));
      bar.style.transform = `scaleX(${Math.max(0.18, progress || (slides.length > 1 ? 1 / slides.length : 1))})`;
      if (count) count.textContent = `${current} / ${slides.length}`;
      hint.classList.toggle('is-start', progress <= 0.04);
      hint.classList.toggle('is-end', progress >= 0.96);
    };

    gallery.addEventListener('scroll', updateGalleryHint, { passive: true });
    window.addEventListener('resize', updateGalleryHint);
    updateGalleryHint();
  });

  document.querySelectorAll('[data-ayros-product-form]').forEach(form => {
    const qty = form.querySelector('[data-ayros-qty]');
    form.querySelectorAll('[data-ayros-qty-minus]').forEach(btn => btn.addEventListener('click', () => { qty.value = Math.max(1, Number(qty.value || 1) - 1); }));
    form.querySelectorAll('[data-ayros-qty-plus]').forEach(btn => btn.addEventListener('click', () => { qty.value = Number(qty.value || 1) + 1; }));

    const variantSelect = form.querySelector('[name="id"]');
    const variantData = form.querySelector('[data-ayros-variants]');
    const submit = form.querySelector('[type="submit"]');
    if (!variantSelect || !variantData) return;

    const variants = JSON.parse(variantData.textContent);
    variantSelect.addEventListener('change', () => {
      const variant = variants.find(item => String(item.id) === String(variantSelect.value));
      if (!variant || !submit) return;
      submit.disabled = !variant.available;
      submit.textContent = variant.available ? submit.dataset.availableText : submit.dataset.soldOutText;
    });
  });

  document.querySelectorAll('[data-ayros-faq-button]').forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.nextElementSibling;
      const marker = btn.querySelector('[data-ayros-faq-marker]');
      const open = content.classList.toggle('is-open');
      if (marker) marker.textContent = open ? '-' : '+';
    });
  });
});
